module.exports = __webpack_public_path__ + "static/media/34.8718583b.jpg";